import { createFileRoute, redirect } from '@tanstack/react-router';
import { getVerifyPermission } from '@repo/shared/helpers';
import { PERMISSIONS } from '@repo/shared/domain';
import { getAuthenticatedSession } from 'src/api/authentication';
import { getEvent } from 'src/api/admin/events';

export const Route = createFileRoute('/_admin/events/$eventId/')({
	loader: async ({ params }) => {
		const event = await getEvent(params.eventId, 'includeArchived=true');

		if (!event) {
			return;
		}

		// Determine the best tab to redirect to based on event configuration
		if (event.type?.Form && event.type.form !== 'event') {
			throw redirect({ to: '/events/$eventId/details', params: { eventId: params.eventId } });
		}

		const session = await getAuthenticatedSession();
		const verifyPermission = getVerifyPermission(session?.user?.permissions || []);

		if (!event.type?.inheritUsersFromGroups && verifyPermission(PERMISSIONS.adminUsersView)) {
			throw redirect({ to: '/events/$eventId/users', params: { eventId: params.eventId } });
		}

		throw redirect({ to: '/events/$eventId/documents', params: { eventId: params.eventId } });
	},
	component: () => null,
});
